const shiftrightWebp = "right-bottom-row-6.webp";
const shiftleftWebp = "left-bottom-row-7.webp";
export const gestureObj = {
  // 对标:['image',left/right,top]
  //shift left
  // 'shift': ["left-bottom-row-7.webp", "0px", "-24px"],
  "`": "left-num-row-7.webp",
  1: "left-num-row-6.webp",
  2: "left-num-row-5.webp",
  3: "left-num-row-4.webp",
  4: "left-num-row-3.webp",
  5: "left-num-row-2.webp",
  6: "right-num-row-0.webp",
  7: "right-num-row-1.webp",
  8: "right-num-row-2.webp",
  9: "right-num-row-3.webp",
  0: "right-num-row-4.webp",
  "-": "right-num-row-5.webp",
  "=": "right-num-row-6.webp",
  Q: "left-top-row-5.webp",
  W: "left-top-row-4.webp",
  E: "left-top-row-3.webp",
  R: "left-top-row-2.webp",
  T: "left-top-row-1.webp",
  Y: "right-top-row-1.webp",
  U: "right-top-row-2.webp",
  I: "right-top-row-3.webp",
  O: "right-top-row-4.webp",
  P: "right-top-row-5.webp",
  "[": "right-top-row-6.webp",
  "]": "right-top-row-7.webp",
  "\\": "right-top-row-8.webp",

  A: "left-home-row-5.webp",
  S: "left-home-row-4.webp",
  D: "left-home-row-3.webp",
  F: "left-home-row-2.webp",
  G: "left-home-row-1.webp",
  H: "right-home-row-1.webp",
  J: "right-home-row-2.webp",
  K: "right-home-row-3.webp",
  L: "right-home-row-4.webp",
  ";": "right-home-row-5.webp",
  "；": "right-home-row-5.webp",
  "'": "right-home-row-6.webp",
  enter: "right-home-row-7.webp",
  Z: "left-bottom-row-5.webp",
  X: "left-bottom-row-4.webp",
  C: "left-bottom-row-3.webp",
  V: "left-bottom-row-2.webp",
  B: "left-bottom-row-1.webp",
  // ===========================
  N: "right-bottom-row-1.webp",
  M: "right-bottom-row-2.webp",
  ",": "right-bottom-row-3.webp",
  ".": "right-bottom-row-4.webp",
  "/": "right-bottom-row-5.webp",
  // shift right
  shift: "right-bottom-row-6.webp",

  space: "space.webp",

  // 组合键
  "~": ["left-num-row-7.webp", shiftrightWebp],
  "!": ["left-num-row-6.webp", shiftrightWebp],
  "@": ["left-num-row-5.webp", shiftrightWebp],
  "#": ["left-num-row-4.webp", shiftrightWebp],
  $: ["left-num-row-3.webp", shiftrightWebp],
  "%": ["left-num-row-2.webp", shiftrightWebp],
  "^": [shiftleftWebp, "right-num-row-0.webp"],
  "&": [shiftleftWebp, "right-num-row-1.webp"],
  "*": [shiftleftWebp, "right-num-row-2.webp"],
  "(": [shiftleftWebp, "right-num-row-3.webp"],
  ")": [shiftleftWebp, "right-num-row-4.webp"],
  _: [shiftleftWebp, "right-num-row-5.webp"],
  "+": [shiftleftWebp, "right-num-row-6.webp"],
  "{": [shiftleftWebp, "right-top-row-6.webp"],
  "}": [shiftleftWebp, "right-top-row-7.webp"],
  // '<': "right-bottom-row-3.webp",
  // '《': "right-bottom-row-3.webp",
  // '>': "right-bottom-row-4.webp",
  // '》': "right-bottom-row-4.webp",
};
export const gestureObjV2 = {
  "`": {
    img: "left-num-row-7.webp",
  },
  1: {
    img: "left-num-row-6.webp",
    // keys: [1, '!'],
  },
  2: {
    img: "left-num-row-5.webp",
    // keys: [2, '@']
  },
  3: {
    img: "left-num-row-4.webp",
    // keys:[3, '#']
  },
  4: {
    img: "left-num-row-3.webp",
    // keys: [4, '$'],
  },
  5: {
    img: "left-num-row-2.webp",
    // keys:[5, '%']
  },
  6: {
    img: "right-num-row-0.webp",
    // keys:['^']
  },
  7: {
    img: "right-num-row-1.webp",
    // keys:['&']
  },
  8: {
    img: "right-num-row-2.webp",
  },
  9: {
    img: "right-num-row-3.webp",
  },
  0: {
    img: "right-num-row-4.webp",
  },

  "-": {
    img: "right-num-row-5.webp",
  },
  "=": {
    img: "right-num-row-6.webp",
  },
  // ["left-num-row-3.webp", shiftrightWebp]
  Q: {
    img: ["left-top-row-5.webp", shiftrightWebp],
    keys: ["q", "{shiftright}"],
  },
  q: {
    img: "left-top-row-5.webp",
  },
  W: {
    img: ["left-top-row-4.webp", shiftrightWebp],
    keys: ["w", "{shiftright}"],
  },
  w: {
    img: "left-top-row-4.webp",
  },
  E: {
    img: ["left-top-row-3.webp", shiftrightWebp],
    keys: ["e", "{shiftright}"],
  },
  e: {
    img: "left-top-row-3.webp",
  },
  R: {
    img: ["left-top-row-2.webp", shiftrightWebp],
    keys: ["r", "{shiftright}"], // 必须要按的键
  },
  r: {
    img: "left-top-row-2.webp",
  },
  T: {
    img: ["left-top-row-1.webp", shiftrightWebp],
    keys: ["t", "{shiftright}"],
  },
  t: {
    img: "left-top-row-1.webp",
  },
  Y: {
    img: [shiftleftWebp, "right-top-row-1.webp"],
    keys: ["{shiftleft}", "y"],
  },
  y: {
    img: "right-top-row-1.webp",
  },
  U: {
    img: [shiftleftWebp, "right-top-row-2.webp"],
    keys: ["u", "{shiftleft}"],
  },
  u: {
    img: "right-top-row-2.webp",
  },
  I: {
    img: [shiftleftWebp, "right-top-row-3.webp"],
    keys: ["{shiftleft}", "i"],
  },
  i: {
    img: "right-top-row-3.webp",
  },
  O: {
    img: [shiftleftWebp, "right-top-row-4.webp"],
    keys: ["{shiftleft}", "o"],
  },
  o: {
    img: "right-top-row-4.webp",
  },
  P: {
    img: [shiftleftWebp, "right-top-row-5.webp"],
    keys: ["{shiftleft}", "p"],
  },
  p: {
    img: "right-top-row-5.webp",
  },

  "[": {
    img: "right-top-row-6.webp",
    // keys: ["[", "【"],
  },
  "]": {
    img: "right-top-row-7.webp",
    // keys: ["]", "】"],
  },
  "\\": {
    img: "right-top-row-8.webp",
  },
  "、": {
    img: "right-top-row-8.webp",
  },

  A: {
    img: ["left-home-row-5.webp", shiftrightWebp],
    keys: ["a", "{shiftright}"],
  },
  a: {
    img: "left-home-row-5.webp",
  },
  S: {
    img: ["left-home-row-4.webp", shiftrightWebp],
    keys: ["{shiftright}", "s"],
  },
  s: {
    img: "left-home-row-4.webp",
  },
  D: {
    img: ["left-home-row-3.webp", shiftrightWebp],
    keys: ["{shiftright}", "d"],
  },
  d: {
    img: "left-home-row-3.webp",
  },
  F: {
    img: ["left-home-row-2.webp", shiftrightWebp],
    keys: ["{shiftright}", "f"],
  },
  f: {
    img: "left-home-row-2.webp",
  },
  G: {
    img: ["left-home-row-1.webp", shiftrightWebp],
    keys: ["{shiftright}", "g"],
  },
  g: {
    img: "left-home-row-1.webp",
  },
  H: {
    img: [shiftleftWebp, "right-home-row-1.webp"],
    keys: ["h", "{shiftleft}"],
  },
  h: {
    img: "right-home-row-1.webp",
  },
  J: {
    img: [shiftleftWebp, "right-home-row-2.webp"],
    keys: ["j", "{shiftleft}"],
  },
  j: {
    img: "right-home-row-2.webp",
  },
  K: {
    img: [shiftleftWebp, "right-home-row-3.webp"],
    keys: ["k", "{shiftleft}"],
  },
  k: {
    img: "right-home-row-3.webp",
  },
  L: {
    img: [shiftleftWebp, "right-home-row-4.webp"],
    keys: ["l", "{shiftleft}"],
  },
  l: {
    img: "right-home-row-4.webp",
  },

  ";": {
    img: "right-home-row-5.webp",
  },
  "；": {
    img: "right-home-row-5.webp",
  },
  "'": {
    img: "right-home-row-6.webp",
  },
  enter: {
    img: "right-home-row-7.webp",
  },
  "↵": {
    img: "right-home-row-7.webp",
  },

  Z: {
    img: ["left-bottom-row-5.webp", shiftrightWebp],
    keys: ["z", "{shiftright}"],
  },
  z: {
    img: "left-bottom-row-5.webp",
  },
  X: {
    img: ["left-bottom-row-4.webp", shiftrightWebp],
    keys: ["x", "{shiftright}"],
  },
  x: {
    img: "left-bottom-row-4.webp",
  },
  C: {
    img: ["left-bottom-row-3.webp", shiftrightWebp],
    keys: ["c", "{shiftright}"],
  },
  c: {
    img: "left-bottom-row-3.webp",
  },
  V: {
    img: ["left-bottom-row-2.webp", shiftrightWebp],
    keys: ["v", "{shiftright}"],
  },
  v: {
    img: "left-bottom-row-2.webp",
  },
  B: {
    img: ["left-bottom-row-1.webp", shiftrightWebp],
    keys: ["b", "{shiftright}"],
  },
  b: {
    img: "left-bottom-row-1.webp",
  },
  N: {
    img: [shiftleftWebp, "right-bottom-row-1.webp"],
    keys: ["{shiftleft}", "n"],
  },
  n: {
    img: "right-bottom-row-1.webp",
  },
  M: {
    img: [shiftleftWebp, "right-bottom-row-2.webp"],
    keys: ["{shiftleft}", "m"],
  },
  m: {
    img: "right-bottom-row-2.webp",
  },

  ",": {
    img: "right-bottom-row-3.webp",
    keys: [",", "，"],
  },
  ".": {
    img: "right-bottom-row-4.webp",
    keys: [".", "。"],
  },
  "/": {
    img: "right-bottom-row-5.webp",
  },

  // shift Right
  shift: {
    img: "right-bottom-row-6.webp",
  },
  space: {
    img: "space.webp",
    keys: ["space", " "],
  },
  " ": {
    img: "space.webp",
    keys: ["space", " "],
  },

  "~": {
    img: ["left-num-row-7.webp", shiftrightWebp],
    keys: ["`", "{shiftright}", "~"],
  },
  "!": {
    img: ["left-num-row-6.webp", shiftrightWebp],
    keys: ["1", "{shiftright}", "!"],
  },
  "@": {
    img: ["left-num-row-5.webp", shiftrightWebp],
    keys: ["2", "{shiftright}", "@"],
  },
  "#": {
    img: ["left-num-row-4.webp", shiftrightWebp],
    keys: ["3", "{shiftright}", "#"],
  },
  "¥": {
    img: ["left-num-row-3.webp", shiftrightWebp],
    keys: ["4", "{shiftright}", "¥"],
  },
  $: {
    img: ["left-num-row-3.webp", shiftrightWebp],
    keys: ["4", "{shiftright}", "$"],
  },
  "%": {
    img: ["left-num-row-2.webp", shiftrightWebp],
    keys: ["5", "{shiftright}", "%"],
  },
  "^": {
    img: [shiftleftWebp, "right-num-row-0.webp"],
    keys: ["6", "{shiftleft}", "^"],
  },
  "&": {
    img: [shiftleftWebp, "right-num-row-1.webp"],
    keys: ["7", "{shiftleft}", "&"],
  },
  "*": {
    img: [shiftleftWebp, "right-num-row-2.webp"],
    keys: ["8", "{shiftleft}", "*"],
  },
  "(": {
    img: [shiftleftWebp, "right-num-row-3.webp"],
    keys: ["9", "{shiftleft}", "("],
  },
  ")": {
    img: [shiftleftWebp, "right-num-row-4.webp"],
    keys: ["0", "{shiftleft}", ")"],
  },
  _: {
    img: [shiftleftWebp, "right-num-row-5.webp"],
    keys: ["-", "{shiftleft}", "_"],
  },
  "+": {
    img: [shiftleftWebp, "right-num-row-6.webp"],
    keys: ["=", "{shiftleft}", "+"],
  },
  "{": {
    img: [shiftleftWebp, "right-top-row-6.webp"],
    keys: ["[", "{shiftleft}", "{"],
    // keys: ["[", "{shiftleft}", "{", "「", "『"],
  },
  "}": {
    img: [shiftleftWebp, "right-top-row-7.webp"],
    keys: ["]", "{shiftleft}", "}"],
    // keys: ["]", "{shiftleft}", "}", "」", "』"],
  },
  "|": {
    img: [shiftleftWebp, "right-top-row-8.webp"],
    keys: ["\\", "{shiftleft}", "|"],
  },
  ":": {
    img: [shiftleftWebp, "right-home-row-5.webp"],
    keys: [";", "{shiftleft}", ":"],
  },
  '"': {
    img: [shiftleftWebp, "right-home-row-6.webp"],
    keys: ["'", "{shiftleft}", '"'],
  },
  "<": {
    img: [shiftleftWebp, "right-bottom-row-3.webp"],
    keys: [",", "{shiftleft}", "<"],
  },
  "《": {
    img: [shiftleftWebp, "right-bottom-row-3.webp"],
    keys: [",", "{shiftleft}", "《"],
  },
  ">": {
    img: [shiftleftWebp, "right-bottom-row-4.webp"],
    keys: [".", "{shiftleft}", ">"],
  },
  "》": {
    img: [shiftleftWebp, "right-bottom-row-4.webp"],
    keys: [".", "{shiftleft}", "》"],
  },
  "?": {
    img: [shiftleftWebp, "right-bottom-row-5.webp"],
    keys: ["/", "{shiftleft}", "?"],
  },
  "？": {
    img: "right-bottom-row-5.webp",
    keys: ["/", "{shiftleft}", "？"],
  },
};
// 只用左手的手势
export const leftGesture = "qwertasdfgzxcvba`12345".split("");
// 只用右手的手势
export const rightGesture = "67890-=yuioph[]\\jkl;'nm,./↵"
  .split("")
  .concat(["shift", "enter"]);

//  组合按键
export const multiGesture = "~!@#$%^&*()_+{}|:<>?QWERTYUIOPASDFGHJKLZXCVBNM"
  .split("")
  .concat(['"']);
export const spaceGesture = ["space"];
export const specialRightGestures = [
  "P",
  "p",
  "[",
  "]",
  "\\",
  "|",
  "{",
  "}",
  ":",
  '"',
  "<",
  ">",
  "?",
  "？",
];
